export const agentTaskNotificationContent = (notification = {}) => {
  if (notification?.kind !== "agent_task") return null;

  const body = notification?.body?.toString() || "";
  if (body.trim()) return body;

  return notification?.text?.toString() || "";
};

export const agentTaskNotificationTextColor = (isDark) =>
  isDark ? "#e5e7eb" : "#111827";
